import React from 'react';
import history from '@/lib/history';
import { pickBy } from 'lodash';
import loginStore from '../store/Login';

export const toLogin = () => {
  history.push('/login');
  loginStore.loginState = false;
  loginStore.userName = null;
};

export const timeBr = value =>
  value ? (
    <div>
      <div>{value.substring(0, 10)}</div>
      <div>{value.substring(10)}</div>
    </div>
  ) : (
    '--'
  );

export const formatDeviceId = string => {
  if (!string) {
    return [];
  } else {
    return string.replace(/\s{1,}/g, ',').split(',');
  }
};

const isValue = val => typeof val === 'number' && (val || val === 0);
export const getValueLabel = (val, fix, unit) =>
  isValue(val) ? val.toFixed(fix) + '' + (unit || '') : '--';

export const BToM = val => (isValue(val) ? (val / 1024).toFixed(2) : '--');
export const toString = json => {
  const filtered = pickBy(json, (value, key) => {
    return key !== 'userId';
  });
  if (json.type === 'online') {
    return `ws-${Object.values(json)
      .filter(p => p && p.length)
      .join('-')}`;
  }
  if (json.type === 'ssh') {
    return `${Object.values(json)
      .filter(p => p.length)
      .join('-')}-${json.userId}`;
  }
  return `ws-${Object.values(filtered)
    .filter(p => p.length)
    .join('-')}_signal_${json.userId}`;
};

export const getEchartsArr = param => {
  return {
    title: param.title,
    xData: [...param.data].map(item => item[param.xDataName]),
    yData: [...param.information].map(item => {
      return {
        name: item.name,
        data: [...param.data].map(a => a[item.dataName])
      };
    }),
    color: [...param.color]
  };
};

export const parseQuery = queryStr =>
  queryStr
    ? queryStr
        .slice(1)
        .split('&')
        .map(i => i.split('='))
        .reduce((a, b) => {
          const [key, val] = b;
          a[key] = val;
          return a;
        }, {})
    : {};



// WEBPACK FOOTER //
// ./src/lib/lib.js